var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.working)?_c('div',{staticClass:"overlay"},[_c('div',{staticClass:"text"},[_vm._v(_vm._s(_vm.text))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }